import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const MockSuccess = () => (
  <FunctionDocs entry="mockSuccess">
    <ComponentExample
      name="Successful response"
      import={import("examples/Api/MockSuccess/SuccessfulResponseExample")}
      rawImport={import(
        "examples/Api/MockSuccess/SuccessfulResponseExample?raw"
      )}
    />
    <ComponentExample
      name="Delayed response"
      description="Requests can be delayed to simulate loading conditions."
      import={import("examples/Api/MockSuccess/DelayedResponseExample")}
      rawImport={import("examples/Api/MockSuccess/DelayedResponseExample?raw")}
    />
    <ComponentExample
      name="Mock Array Data example"
      description="A helper class that can be instantiated with an array of mock data, and provides methods to paginate/filter the results."
      import={import("examples/Api/MockSuccess/MockArrayDataExample")}
      rawImport={import("examples/Api/MockSuccess/MockArrayDataExample?raw")}
    />
  </FunctionDocs>
);

export default MockSuccess;
